(function() {
  function initBenefitsSlide() {
    var wrapper = document.querySelector('.corial-product-image-wrapper');
    var productMedia = document.querySelector('product-media');
    if (!wrapper || !productMedia) return;

    var attempts = 0;

    function applySlideState(swiperWrapper) {
      var hasBenefits = !!wrapper.querySelector('.corial-benefits--product');
      var slides = Array.from(swiperWrapper.querySelectorAll('.swiper-slide'));
      var activeIndex = slides.findIndex(function(s) {
        return s.classList.contains('swiper-slide-active');
      });
      wrapper.classList.toggle('benefits-slide-active', hasBenefits && activeIndex === 1);
    }

    function setup() {
      var swiperWrapper = productMedia.querySelector('.swiper-wrapper');
      if (!swiperWrapper) {
        if (++attempts < 30) setTimeout(setup, 300);
        return;
      }

      // MutationObserver: deteta mudanças de classe nos slides (funciona no desktop)
      var observer = new MutationObserver(function() {
        applySlideState(swiperWrapper);
      });
      observer.observe(swiperWrapper, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      // transitionend: dispara quando o Swiper termina de deslizar (mobile + desktop)
      // Neste momento o swiper-slide-active já está na slide correta
      swiperWrapper.addEventListener('transitionend', function() {
        applySlideState(swiperWrapper);
      });

      // touchend com dois delays como segurança extra em mobile
      wrapper.addEventListener('touchend', function() {
        setTimeout(function() { applySlideState(swiperWrapper); }, 150);
        setTimeout(function() { applySlideState(swiperWrapper); }, 450);
      }, { passive: true });
    }

    setup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitsSlide);
  } else {
    initBenefitsSlide();
  }
})();
